var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "123.000000pt",
    viewBox: "0 0 300.000000 123.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,123.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827 971 c-9 -35 65 -45 83 -11 9 17 8 20 -12 20 -13 0 -33 3 -44 6 -16 4 -23 0 -27 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106 918 c-3 -7 -14 -128 -25 -268 -12 -140 -24 -276 -27 -302 l-6 -48 50 0 49 0 7 88 c4 48 9 106 12 130 l6 42 55 0 56 0 -7 -72 c-4 -40 -9 -99 -13 -130 l-6 -58 50 0 49 0 26 308 c15 169 23 311 19 315 -5 5 -26 7 -47 5 l-39 -3 -7 -65 c-3 -36 -9 -95 -13 -132 l-7 -68 -55 0 -55 0 8 93 c5 50 9 110 9 132 0 40 0 40 -43 43 -28 2 -44 -1 -46 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1486 898 c-3 -18 -8 -63 -11 -100 l-7 -68 51 0 50 0 3 48 3 47 59 3 c57 3 58 2 52 -20 -3 -13 -6 -37 -6 -54 0 -29 -7 -35 -93 -82 -138 -77 -127 -62 -138 -187 -5 -61 -11 -127 -13 -147 l-4 -38 143 0 c110 0 145 3 154 14 7 8 15 53 18 100 l6 86 -42 0 c-35 0 -43 -4 -51 -26 -6 -14 -10 -39 -10 -55 0 -29 -1 -29 -55 -29 -54 0 -55 1 -55 29 0 15 3 49 6 75 l7 46 101 57 c56 31 104 61 108 67 3 5 9 37 13 70 3 34 8 82 11 108 5 38 2 50 -15 67 -19 19 -33 21 -151 21 l-129 0 -5 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867 888 c-3 -23 -3 -46 -1 -50 3 -4 50 -8 106 -8 l100 0 -6 -52 c-3 -29 -10 -114 -16 -188 -17 -216 -11 -200 -76 -200 l-55 0 3 52 3 53 -45 0 -45 0 -7 -45 c-3 -25 -7 -69 -7 -97 l-1 -53 139 0 c112 0 141 3 151 15 12 14 59 464 60 573 l0 42 -149 0 -148 0 -6 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 863 c0 -19 9 -21 101 -28 85 -6 104 -4 117 9 9 8 14 17 11 20 -2 2 -55 7 -116 11 -109 7 -113 7 -113 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817 690 c-72 -104 -97 -146 -92 -160 4 -11 9 -20 13 -20 4 1 54 69 111 151 81 118 101 153 90 160 -8 5 -16 9 -19 9 -3 0 -50 -63 -103 -140z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 760 c0 -14 7 -20 23 -20 12 0 89 -7 171 -14 138 -13 151 -13 162 2 7 9 11 18 9 20 -2 3 -316 32 -347 32 -11 0 -18 -8 -18 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2302 670 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2331 668 c1 -24 3 -27 6 -10 2 12 9 20 14 17 5 -3 6 1 3 9 -11 27 -24 17 -23 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2368 675 c-6 -30 -3 -43 8 -33 3 4 4 19 2 35 l-3 28 -7 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400 690 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2441 682 c0 -13 -5 -20 -11 -17 -6 3 -7 -1 -4 -10 10 -24 27 -2 21 26 l-4 24 -2 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2532 685 c-2 -27 13 -51 22 -36 4 6 3 11 -3 11 -5 0 -12 10 -14 23 -4 19 -4 19 -5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2589 674 c-5 -15 -7 -29 -5 -32 3 -2 8 8 12 24 6 25 8 26 15 9 7 -19 8 -18 8 3 1 30 -17 28 -30 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2787 693 c-15 -14 -7 -53 11 -53 14 0 15 2 2 10 -13 9 -13 11 0 20 11 7 11 10 2 10 -7 0 -10 5 -7 10 7 11 2 13 -8 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2500 667 c0 -8 -8 -18 -17 -20 -17 -4 -17 -5 0 -6 18 -1 35 25 23 36 -3 4 -6 -1 -6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2743 664 c-15 -16 -16 -24 -4 -24 8 0 24 30 19 35 -2 2 -9 -3 -15 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 630 c22 -43 21 -43 44 -34 25 10 -11 74 -41 74 l-23 0 20 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2651 654 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 563 c51 -112 54 -115 73 -103 12 7 6 26 -30 104 -36 80 -47 96 -66 96 -22 0 -21 -3 23 -97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541 643 c20 -49 155 -333 159 -333 3 0 11 4 19 9 11 7 0 40 -60 168 -62 131 -79 159 -98 161 -13 2 -22 0 -20 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 505 c-48 -71 -56 -89 -48 -107 8 -19 15 -12 77 76 54 77 66 100 55 107 -8 5 -17 9 -20 9 -3 0 -32 -38 -64 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290 571 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2381 558 c-1 -31 -27 -39 -34 -10 -4 16 -5 16 -6 -1 -1 -21 26 -34 41 -19 5 5 8 20 5 33 -4 22 -4 22 -6 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2491 558 c-1 -31 -27 -39 -34 -10 -4 16 -5 16 -6 -1 -1 -21 26 -34 41 -19 5 5 8 20 5 33 -4 22 -4 22 -6 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2532 555 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2572 550 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2601 564 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2661 553 c1 -18 3 -21 6 -10 2 9 9 15 14 12 5 -3 6 1 3 9 -10 26 -24 18 -23 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2698 555 c-3 -14 -1 -28 3 -31 5 -3 9 9 9 25 0 38 -6 40 -12 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2730 571 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2320 542 c0 -6 -8 -13 -17 -15 -16 -4 -16 -5 -1 -6 18 -1 34 16 24 26 -3 4 -6 1 -6 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2600 528 c0 -4 6 -8 14 -8 8 0 17 4 20 8 2 4 -4 8 -15 8 -10 0 -19 -4 -19 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2418 523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2738 523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856 324 c-18 -26 -18 -55 -1 -61 6 -1 20 12 32 31 16 25 19 36 10 45 -16 16 -23 14 -41 -15z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64e2c75f1b2fe4adb0f1ee28b081c842.svg";
export { ForwardRef as ReactComponent };